module.exports = __webpack_public_path__ + "static/recognized_by@2x-68911fcad365aa14b7bc024e97b51ac2.png";